import { configuration } from "@faire/web/common/settings/declarations/configuration";

/**
 * Batch 11 Sign up facepiles subtitle
 */
export const FE_ENABLE_PDP_NAVIGATION_STAGING = configuration({
  name: "FE_ENABLE_PDP_NAVIGATION_STAGING",
  identifier: "SessionToken",
  client: ["RETAILER", "VISITOR_WEB", "VISITOR_PERF_APP_WEB"],
  defaultValue: false,
  productArea: "LOGGED_OUT_RETAILERS",
});
